module.exports = __webpack_public_path__ + "img/SketchPng6b440ef14ed433b9cb4261fe4d9f6de53dfb24ea70bca063a320727c0744a831.ff20c44f.png";